export default "__VITE_ASSET__CPELV9sj__"